import { render, staticRenderFns } from "./CheckboxUnChecked.vue?vue&type=template&id=23a28b59&scoped=true"
import script from "./CheckboxUnChecked.vue?vue&type=script&lang=js"
export * from "./CheckboxUnChecked.vue?vue&type=script&lang=js"
import style0 from "./CheckboxUnChecked.vue?vue&type=style&index=0&id=23a28b59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a28b59",
  null
  
)

export default component.exports